<template>
    <div class="relative">
        <project-list-filter
            :close-callback="closeFilterCallback"
            :expanded="expandedFilter"
            :data="projectsData"
            :fetch="fetchProjects"
        ></project-list-filter>

        <div class="flex flex-wrap items-center mb-6">
            <h2 class="text-xl flex items-center"><span class="rounded-full h-6 w-1 bg-orange-500 inline-block mr-2"></span> Zoznam projektov ({{ hasProjects ? projects.totalRecords : 0 }})</h2>
    
            <button
                class="ml-auto py-2 rounded px-4 flex items-center"
                :class="filterEnabled ? 'text-orange-400' : ''"
                v-ripple
                @click="() => this.expandedFilter = !this.expandedFilter"
            >
                <i class="material-icons">filter_list</i>
            </button>
            <md-button :to="{name: 'projects.add'}" class="md-primary md-dense">
                <span>Nový projekt</span>
            </md-button>
        </div>

        <div class="flex items-stretch flex-wrap -mx-3">
            <ProjectItem
                v-for="project in projects.data"
                :key="'project'+project.id"
                :project="project"
            />
        </div>

        <ul class="flex pb-6 mt-6" v-if="hasProjects && projects.totalPages > 1">
            <li
                v-ripple
                class="w-10 h-10 text-center py-2 px-1 text-gray-500 rounded-full mx-2 hover:bg-gray-100 cursor-pointer"
                :aria-disabled="isFirstPage"
                :disabled="isFirstPage"
                @click="() => this.jumpPage(1)"
            >
                <font-awesome icon="arrow-left"></font-awesome>
            </li>
            <li
                v-ripple
                class="w-10 h-10 text-center py-2 px-1 rounded-full mx-2 hover:bg-gray-100 cursor-pointer"
                v-for="page in pagesNumber"
                :key="'page'+page"
                :class="{'shadow-md bg-white text-white bg-orange-500 hover:bg-orange-400': page === projects.actualPage, 'text-gray-500': page !== projects.actualPage}"
                @click="() => jumpPage(page)"
            >{{ page }}</li>
            <li
                v-ripple
                class="w-10 h-10 text-center py-2 px-1 text-gray-500 rounded-full mx-2 hover:bg-gray-100 cursor-pointer"
                :aria-disabled="isLastPage"
                :disabled="isLastPage"
                @click="() => this.jumpPage(projects.totalPages)"
            >
                <font-awesome icon="arrow-right"></font-awesome>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { EventBus, hasPermission } from "../../utils";
import ProjectListFilter from "./ProjectListFilter";
import ProjectItem from "./ProjectItem";

export default {
    name: "ProjectList",

    components: {
        ProjectListFilter,
        ProjectItem
    },

    data() {
        return {
            showDoneProjects: false,
            perPage: 16,
            offset: 4,
            expandedFilter: false
        };
    },

    metaInfo() {
        return {
            title: `Zoznam projektov (${this.projects.totalRecords})`
        };
    },

    computed: {
        ...mapState({
            projects: state => state.projects.all,
            user: state => state.account.user,
            filterEnabled: state => state.filter.enabled
        }),

        hasProjects() {
            return this.$store.getters.hasProjects;
        },

        isFirstPage() {
            return this.projects.actualPage === 1;
        },

        isLastPage() {
            return (
                this.projects.totalPages === this.$store.getters.getProjectsPage
            );
        },

        pagesNumber() {
            let from = this.projects.actualPage - this.offset;
            if (from < 1) {
                from = 1;
            }

            let to = from + this.offset * 2;
            if (to >= this.projects.totalPages) {
                to = this.projects.totalPages;
            }

            let pagesArray = [];
            for (let page = from; page <= to; page++) {
                pagesArray.push(page);
            }

            return pagesArray;
        }
    },

    mounted() {
        if (this.$route.query.page) {
            this.$store.commit("setProjectsPage", this.$route.query.page);
        } else {
            this.$router.push({
                query: { page: this.$store.getters.getProjectsPage }
            });
        }

        if (!this.$store.getters.isUserFetched) {
            EventBus.$on("userFetched", () => {
                this.fetchProjects(this.$store.getters.getProjectsPage);
            });
        } else {
            this.fetchProjects(this.$store.getters.getProjectsPage);
        }
    },

    methods: {
        // Simple mutators
        hasPermission(p) {
            return hasPermission(this.user, p);
        },

        closeFilterCallback() {
            if (this.expandedFilter == false) return;

            this.expandedFilter = false;
        },

        // Another else
        fetchProjects(page = 1, data = {}) {
            if (Object.keys(data).length < 1) {
                data = {
                    all: this.hasPermission("SHOW_ALL_PROJECTS"),
                    paginate: true,
                    done: this.showDoneProjects,
                    page,
                    limit: this.perPage
                };
            }

            return this.$store.dispatch("fetchProjects", data);
        },

        projectsData() {
            return {
                all: this.hasPermission("SHOW_ALL_PROJECTS"),
                paginate: true,
                done: this.showDoneProjects,
                page: this.$store.getters.getProjectsPage,
                limit: this.perPage
            };
        },

        // Paginator
        nextPage() {
            let nextPage = this.$store.getters.getProjectsPage + 1;
            window.scrollTo(0, 0);

            this.fetchProjects(nextPage).then(r => {
                this.$store.commit("setProjectsPage", nextPage);
                this.$router.push({ query: { page: nextPage } });
            });
        },

        prevPage() {
            let prevPage = this.$store.getters.getProjectsPage - 1;
            window.scrollTo(0, 0);

            this.fetchProjects(prevPage).then(r => {
                this.$store.commit("setProjectsPage", prevPage);
                this.$router.push({ query: { page: prevPage } });
            });
        },

        jumpPage(page) {
            this.fetchProjects(page).then(r => {
                window.scrollTo(0, 0);
                this.$store.commit("setProjectsPage", page);
                this.$router.push({ query: { page } });
            });
        }
    }
};
</script>
